import "./ErrorPopup.scss";
import { useCallback } from "react";
import { exchangeActions } from "../../../store/reducers/exchange";
import { signInActions } from "store/reducers/signIn";
import Button from "components/Button/Button";
import { useAppSelector, useAppDispatch } from "store";
import { useTranslation } from "react-i18next";
import { scrollToSection } from "utils/scroll";

const ErrorPopup = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const {
    errorHeader,
    errorText,
    isSupport ,
  } = useAppSelector((state) => state.exchange);
  const { errorHeaderSignIn, errorTextSignIn } = useAppSelector(
    (state) => state.signIn
  );

  const errorHeaderPopup = errorHeader || errorHeaderSignIn;
  const errorTextPopup = errorText || errorTextSignIn;

  const setIsOpenServerErrorPopup = useCallback(() => {
    dispatch(exchangeActions.setIsOpenServerErrorPopup(false));
    dispatch(signInActions.setIsOpenServerErrorPopupSignIn(false));
  }, [dispatch]);

  return (
    <div className="error-popup-container">
      <div className="error-popup">
        <div className="error-popup-content">
          <div className="error-popup-header">
            {t(`popups.errorPopup.title.${errorHeaderPopup}`)}
          </div>
          <div className="error-popup-desc">
            {t(`popups.errorPopup.description.${errorTextPopup}`)}
          </div>
          {isSupport && (
            <Button
              btnName="Support"
              className="blue-btn"
              onClick={() => scrollToSection("contact")}
            />
          )}
          <Button
            btnName={t("buttons.cancel")}
            className={isSupport ? "border-btn" : "blue-btn"}
            onClick={setIsOpenServerErrorPopup}
          />
        </div>
      </div>
    </div>
  );
};

export default ErrorPopup;
